<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Allocate Student For Quiz</span>
        </v-row>
        <br />
        <v-card class="mx-auto card">
            <v-card-title class="heading justify-center">
                <span>Allocate Student For Quiz</span>
            </v-card-title>
            <div>
                <div >
                    <v-row justify="center" style="padding:10px" >
                        <v-col lg="3" cols="12" sm="12">
                            <label>Registration Number</label>
                            <v-text-field v-model="registration_no" variant="outlined"
                                class="form-control" :rules="[(v) => !!v || 'required']" placeholder="Enter Registration Number">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="justify-center">
                            <v-col lg="3" cols="12" sm="12" style="padding-top:0">
                            <v-btn class=" button" :loading="loading4" :disabled="loading4" @click="getData">
                                Add Student To Quiz
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import moment from "moment";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            dates: [],
            slot_list: [],
            loading4: false,
            details_id: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            examlearnerlist: "",
            search: "",
            examtimetableid:"",
            registration_no:null,
        }),

        mounted() {
            this.examtimetableid = this.$route.params.examtimetableid;
            const data = {
                examtimetableid: this.examtimetableid,
            };
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getData()
            {
                if (this.registration_no == null) {
                this.showSnackbar("#b71c1c", "Please Enter Registration Number");
                return;
                }
                const data = {
                    examtimetableid: this.examtimetableid,
                    registration_no : this.registration_no,
                };
                if(this.registration_no!== null){
                    this.loading4 = true;
                            axios
                                .post("QuizDashboard/allocateStudentForQuiz", data)
                                .then((res) => {
                                if (res.data.status == "200" && res.data.msg == "success") {
                                    this.showSnackbar("#4caf50", "Student Allocated For Quiz Successfully..."); // show snackbar on success
                                    this.loading4 = false;
                                } 
                                else if (res.data.status == "201") {
                                    this.loading4 = false;
                                    this.showSnackbar("#b71c1c", "Learner Not Found For Given Registration Number."); // show snackbar on success
                                } 
                                else if (res.data.status == "202") {
                                    this.loading4 = false;
                                    this.showSnackbar("#b71c1c", "Subject Registration Not Found For Subject."); // show snackbar on success
                                } 
                                else if (res.data.status == "203") {
                                    this.loading4 = false;
                                    this.showSnackbar("#b71c1c", "Student Allready Allocated To Quiz."); // show snackbar on success
                                } 
                                else { 
                                    this.loading4 = false;
                                    this.showSnackbar("#b71c1c", "Something Went Wrong....");
                                }
                            })
                                .catch((error) => {
                                    this.showSnackbar("#b71c1c", "Something went wrong...");
                                    this.loading4 = false;
                                });
                }
            },
        },
    };
</script>
